import React from 'react';
import type { Workspace } from 'types/Workspace';

export interface WorkspaceContextValue {
  currentWorkspaceID: string | null | undefined;
  setWorkspace: (workspace: string) => void;
  getWorkspace: () => Workspace | undefined;
}

// Create a context with initial value as null
export const WorkspaceContext = React.createContext<
  WorkspaceContextValue | undefined
>(undefined);
